import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth.service';
import {Events} from '@ionic/angular';

@Component({
  selector: 'app-promoga-alert',
  templateUrl: './promoga-alert.component.html',
  styleUrls: ['./promoga-alert.component.scss'],
})
export class PromogaAlertComponent implements OnInit {

  static countDownTimer = '';
  static count;
  static intervalRemover;
  static userEmail;
  static showResendBtn;
  public classRef = PromogaAlertComponent;

  constructor(public authService: AuthService, public events: Events) {
    this.events.subscribe('user:signup',(data)=>{
      this.onSignupListener(data);
    });
    this.events.subscribe('user:email_verified',(data)=>{
          this.onEmailVerification(data);
      });
    this.events.subscribe('user:logout',(data)=>{
      this.onLogoutListener();
    });
   }
   
   ngOnInit(){}
   
   onSignupListener(data) {
    if(data && data.email && this.classRef.userEmail == data.email){
      return;
    }
    this.classRef.userEmail = data.email;
    this.classRef.count = 30;
    if(!this.classRef.intervalRemover){
      this.classRef.intervalRemover = setInterval(() => {
        this.classRef.count--;
        this.classRef.countDownTimer = '00:'+(this.classRef.count > 9 ? '' : '0')+ this.classRef.count;
        if(this.classRef.count == 0){
          clearInterval(this.classRef.intervalRemover);
          this.classRef.showResendBtn = true;
        }
      }, 1000);
    }  
  }

  onEmailVerification(data) {
      this.classRef.userEmail = data.email;
      this.classRef.count = 0;
      this.classRef.showResendBtn = true;
  }

  onLogoutListener(){
    this.classRef.userEmail = null;
    this.classRef.intervalRemover = null;
  }

  onResendClick(){
    this.authService.resendEmailVerification();
    this.classRef.showResendBtn = false;
  }
  

}
